import React from 'react';

/**
 * Lightweight shared table shell for consistent portal data surfaces.
 */
export const DataTable = ({ children, className = '' }) => {
  return <div className={`portalr-dataTable ${className}`.trim()}>{children}</div>;
};

export const DataTableEmpty = ({ children }) => {
  return <div className="portalr-dataTableEmpty">{children}</div>;
};

